<h2 style="color:#f44336;" mat-dialog-title>Be careful when changing these formulas!</h2>
<mat-dialog-content class="mat-typography">
  <form [formGroup]="form">
    <mat-form-field appearance="fill">
      <mat-label>Static Fields</mat-label>
      <mat-select (selectionChange)="onChange($event)" formControlName="type">
        <mat-option *ngFor="let item of rows" [value]="item">
          {{item}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Dynamic Fields</mat-label>
      <mat-select (selectionChange)="onChangeDynamicField($event)" formControlName="dynamic_field">
        <mat-option *ngFor="let field of dynamicField" [value]="field.value">
          {{field.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Dynamic Fields Rules</mat-label>
      <mat-select (selectionChange)="loadRule()" formControlName="dynamic_field_rule">
        <mat-option *ngFor="let field of dynamicField" [value]="field.value">
          {{field.title}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>

  <ngx-codemirror
    #codeMirror
    [(ngModel)]="codemirrorContent"
    [options]="codemirrorConfig"
    (cursorActivity)="cursorActivity($event)"
    (ngModelChange)="setEditorContent($event)"
  ></ngx-codemirror>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button cdkFocusInitial (click)="saveRule()">Save</button>
</mat-dialog-actions>
